document.addEventListener('DOMContentLoaded', function() {

   const footerSocialLinks = document.querySelectorAll('.footer__logo .social-icons li a');
    if(footerSocialLinks){
      for(let link of footerSocialLinks){
        link.setAttribute('aria-label','Social Media Link (Opens in new tab)')
      }
    }
// Poup toggle
  const popUpToggle = document.querySelector('.popup-toggle-btn');
  if(popUpToggle){
    popUpToggle.setAttribute('role','button')
  }

  // Fotter Nav Links
    const footerNavLinks = document.querySelectorAll('.site-footer__linklist li a');
    if(footerNavLinks){
      for(let link of footerNavLinks){
        link.setAttribute('role','button')
      }
    }

  const emailText = document.querySelector('.footer__collapsible p a');
  if(emailText){
    emailText.setAttribute('aria-label','Email Link (Opens in new tab)')
  }

  const shopMonthText = document.querySelectorAll('.shop-by-stage__item-subtitle');

   if(shopMonthText){
      for(let text of shopMonthText){
        text.setAttribute('role','heading')
      }
    }
  
 const newletterFormText =  document.querySelector('.newsletter-section__content p.h1');
  if(newletterFormText){
    newletterFormText.setAttribute('role','heading')
  }

  const slickSlider = document.querySelectorAll('.why-order-card.slick-slide');
     if(slickSlider){
      for(let text of slickSlider){
        text.removeAttribute("aria-describedby");
      }
    }
  // Header Menu Dropdown
   const dropDownMenu =  document.querySelector('#site-nav-item--1');
    dropDownMenu.setAttribute('aria-haspopup','true')
    dropDownMenu.setAttribute('aria-expanded','false')
   const subMenu = document.querySelectorAll('.site-nav__dropdown-link ');

   if(subMenu){
      for(let link of subMenu){
        link.setAttribute('aria-expanded','false')
      }
    }

  // home slider dots
  const sliderDots =  document.querySelector('.flickity-page-dots');
    if(sliderDots){
       sliderDots.setAttribute('aria-labe','Slider Pagination')
        sliderDots.setAttribute('role','navigation')
    }
  $('.flickity-page-dots .dot').attr("role", "button");
   $('.flickity-page-dots .dot').attr("tabindex", "0");
  
  const image = document.querySelector('.site-header .mobile-logo');
const anchor = document.createElement('a');
anchor.href = 'https://organicformulashop.com/'; 
image.parentNode.insertBefore(anchor, image);
anchor.appendChild(image);




});